const productionServerIp = 'https://casadata.io';
const developmentServerPort = '5000';

export const isPrivateIpv4Host = (hostname) => {
    return /^(127\.0\.0\.1|localhost|0\.0\.0\.0|::1)$/i.test(hostname)
        || /^10\./.test(hostname)
        || /^192\.168\./.test(hostname)
        || /^100\.(6[4-9]|[7-9]\d|1[01]\d|12[0-7])\./.test(hostname)
        || /^172\.(1[6-9]|2\d|3[0-1])\./.test(hostname);
};

const detectServerIp = () => {
    if (typeof window === 'undefined') {
        return productionServerIp;
    }

    const protocol = String(window.location.protocol || '').toLowerCase();
    const hostname = String(window.location.hostname || '').toLowerCase();
    const port = String(window.location.port || '');

    // Never point an HTTPS page to the local HTTP API, because the browser will block mixed content.
    if (protocol === 'https:') {
        return productionServerIp;
    }

    if (isPrivateIpv4Host(hostname) || (protocol === 'http:' && port === '3000')) {
        const apiHostname = hostname === '::1' ? '[::1]' : hostname;
        return `${protocol}//${apiHostname}:${developmentServerPort}`;
    }

    return productionServerIp;
};

const serverIp = detectServerIp();

export default serverIp;
